import React from 'react';

import { Box, Button } from '@/components/ui';

type Props = {
  durations: any[];
  activeDuration: string;
  handleDurationChange: (durationId: string) => void;
};

export const BundlesDurations = ({ durations, activeDuration, handleDurationChange }: Props) => (
  <Box className="flex flex-nowrap justify-around gap-0 md:gap-2 p-1 bg-[var(--color-grey-300)] rounded-xl">
    {durations.map((duration) => {
      const isActive = activeDuration === duration.id;

      return (
        <Button
          key={duration.id}
          onClick={() => handleDurationChange(duration.id)}
          className={`
            relative group flex items-center gap-2
            px-1 py-1 rounded-md text-xs
            sm:px-3 sm:py-1.5 sm:rounded-lg sm:text-sm
            md:px-5 md:py-2 md:rounded-xl md:text-base
            whitespace-nowrap font-medium
            transition-all duration-300 ease-in-out
            ${
              isActive
                ? 'bg-[var(--color-white)] text-[var(--color-grey-800)] hover:bg-[var(--color-white)]'
                : 'bg-transparent text-[var(--color-grey-800)] hover:bg-[var(--color-white)]'
            }
          `}
        >
          {duration.label}

          {!!duration.discount && (
            <Box
              component="span"
              className="
                ml-1 px-2 py-[2px] xs:text-xs md:text-md rounded-lg
                transition-all duration-300
                bg-[var(--color-violet-lighter)] text-[var(--color-violet-dark)]
                group-hover:bg-[var(--color-violet-lighter)] group-hover:text-[var(--color-violet-dark)]
              "
            >
              {duration.discount}
            </Box>
          )}

          {isActive && (
            <Box
              component="span"
              className="absolute inset-0 rounded-xl bg-[var(--color-white)]/10 blur-md -z-10"
            />
          )}
        </Button>
      );
    })}
  </Box>
);
